<template>
  <div class="sk-reset-page">
    <div class="sk-topbar">
      <a href="#" class="sk-logo" @click.prevent>
        <img src="https://sentrykit.com/wp-content/uploads/2026/04/Sk-2.0-logo-white.png" alt="SentryKit" style="height:48px;width:auto;display:block;">
      </a>
    </div>

    <div class="sk-main">
      <div class="sk-card">
        <div class="sk-card-header">
          <h2>Set a new password</h2>
          <p>Choose a strong password with at least 8 characters.</p>
        </div>

        <div v-if="error" class="sk-error-msg">
          <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor"><circle cx="12" cy="12" r="10" stroke-width="2"/><path stroke-width="2" d="M12 8v4m0 4h.01"/></svg>
          {{ error }}
        </div>

        <div v-if="message" class="sk-success-msg">
          <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
          {{ message }}
        </div>

        <form @submit.prevent="resetPassword">
          <div class="sk-form-row">
            <div class="sk-field">
              <label>New Password <span class="req">*</span></label>
              <div class="sk-password-wrap">
                <input class="sk-input" :type="showPassword ? 'text' : 'password'" v-model="password" placeholder="Min. 8 characters" required>
                <button type="button" class="sk-toggle-pw" @click="showPassword = !showPassword">
                  <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/><path d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/></svg>
                </button>
              </div>
              <div v-if="password && passwordWeak" class="sk-field-error">Must be 8+ characters with a letter and number/symbol</div>
            </div>
          </div>

          <div class="sk-form-row sk-mt-4">
            <div class="sk-field">
              <label>Confirm Password <span class="req">*</span></label>
              <div class="sk-password-wrap">
                <input class="sk-input" :type="showPassword2 ? 'text' : 'password'" v-model="password2" placeholder="Repeat password" required>
                <button type="button" class="sk-toggle-pw" @click="showPassword2 = !showPassword2">
                  <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/><path d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/></svg>
                </button>
              </div>
              <div v-if="password2 && passwordMismatch" class="sk-field-error">Passwords do not match</div>
            </div>
          </div>

          <button type="submit" class="sk-btn sk-btn-primary sk-mt-6" :class="{ loading: working }" :disabled="!isFormValid || working">
            <span v-if="working" class="sk-spinner"></span>
            <span v-else>Set Password →</span>
          </button>
        </form>

        <div class="sk-login-link">Remember your password? <router-link to="/login">Log in</router-link></div>
      </div>
    </div>
  </div>
</template>

<script>
import './styles/signup-flow.css'

export default {
  data: function () {
    return {
      password: '',
      password2: '',
      showPassword: false,
      showPassword2: false,
      error: '',
      message: '',
      working: false
    }
  },
  computed: {
    passwordWeak: function () {
      var regex1 = /.*[_\- !"?$%^&*()+={}[\]:;@'~#|<>,.?\\/0123456789].*/
      var regex2 = /.*[a-zA-Z].*/
      return this.password.length < 8 || !regex1.test(this.password) || !regex2.test(this.password)
    },
    passwordMismatch: function () {
      return this.password2 !== this.password
    },
    isFormValid: function () {
      return this.password.length >= 8 && !this.passwordWeak && !this.passwordMismatch
    }
  },
  methods: {
    resetPassword: function () {
      if (!this.isFormValid) return
      this.working = true
      this.error = ''
      this.$http.post('/api/auth/resetpassword', {
        newPassword: this.password,
        passwordResetToken: this.$route.query.token
      }).then(
        () => {
          this.message = 'Your password has been successfully changed. Redirecting to login...'
          this.working = false
          setTimeout(() => { this.$router.push('/login') }, 2000)
        },
        (response) => {
          this.error = response.body.message || 'Failed to reset password. Please try again.'
          this.working = false
          setTimeout(() => { this.error = '' }, 5000)
        }
      )
    }
  }
}
</script>

<style scoped>
.sk-reset-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  font-family: 'Roboto', 'DM Sans', -apple-system, sans-serif;
  -webkit-font-smoothing: antialiased;
}

.sk-success-msg {
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  border-radius: 8px;
  padding: 12px 16px;
  font-size: 13px;
  color: #166534;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}
</style>



// WEBPACK FOOTER //
// PasswordResetPage.vue?2341d097